var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-row",
    { attrs: { gutter: 24 } },
    [
      _c(
        "a-col",
        { attrs: { md: 24 } },
        [
          _c(
            "a-card",
            { style: _vm.cardStyle, attrs: { bordered: false } },
            [
              _c("div", { staticClass: "media-page-header" }, [
                _c("span", { staticClass: "media-page-title" }, [
                  _vm._v("素材管理"),
                ]),
                _c("span", { staticClass: "media-page-tip" }, [
                  _vm._v(
                    "统一维护图片素材，上传走主工程统一存储（OSS/本地自动切换），各业务页从素材库引用"
                  ),
                ]),
              ]),
              _c("media-grid", { on: { preview: _vm.onPreview } }),
              _c(
                "a-modal",
                {
                  attrs: {
                    visible: _vm.previewVisible,
                    footer: null,
                    width: 860,
                    title: "图片预览",
                  },
                  on: {
                    cancel: function ($event) {
                      _vm.previewVisible = false
                    },
                  },
                },
                [
                  _c("img", {
                    staticStyle: { width: "100%" },
                    attrs: { src: _vm.previewUrl, alt: "图片预览" },
                  }),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }